import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const DonutChart = ({ title, data, height = 250 }) => {
    const chartData = {
        labels: data.map((d) => d.name),
        datasets: [
            {
                data: data.map((d) => d.value),
                backgroundColor: ["#4F46E5", "#F43F5E"], // Male / Female
                hoverBackgroundColor: ["#4F46E5", "#F43F5E"],
                borderColor: "#ffffff",
                borderWidth: 3,
            },
        ],
    };

    const chartOptions = {
        cutout: "65%",
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    boxWidth: 12,
                    boxHeight: 12,
                    padding: 15,
                    font: {
                        size: 11,
                    },
                },
            },

            tooltip: {
                enabled: true,
                backgroundColor: "#ffffff",       // <-- White background
                titleColor: "#000000",            // Black title text
                bodyColor: "#000000",             // Black body text
                borderColor: "#e2e8f0",           // Light gray border
                borderWidth: 1,
                padding: 10,
                cornerRadius: 8,
                displayColors: false,             // Hide colored box for cleaner UI
                callbacks: {
                    label: function (ctx) {
                        const dataset = ctx.chart.data.datasets[0].data;
                        const total = dataset.reduce((a, b) => a + b, 0);
                        const value = ctx.parsed;
                        const percent = ((value / total) * 100).toFixed(1);
    
                        return `${ctx.label}: ${percent}%`;
                    }
                }
            },
            datalabels: {
                display: false, // hide numbers on graph
            },
        },
    };

    return (
        <div className="bg-white shadow-md rounded-xl p-4">
            <h3 className="text-sm font-semibold text-slate-700 mb-3">{title}</h3>

            <div style={{ height }}>
                <Doughnut data={chartData} options={chartOptions} />
            </div>
        </div>
    );
};

export default DonutChart;
